module.exports = __webpack_public_path__ + "media/svg/st-c321f51b.svg";